"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBaseBindingFileIssues = appBaseBindingFileIssues;
exports.appBaseBindingColumnRefs = appBaseBindingColumnRefs;
const app_base_bindings_1 = require("./app-base-bindings");
const app_base_contract_1 = require("./app-base-contract");
const app_base_url_policy_1 = require("./app-base-url-policy");
/** DOM supplied by the host: the same contract runs in authoring and StreamKit. */
function appBaseBindingFileIssues(files, parse, routes) {
    const issues = [];
    for (const file of files) {
        if ((0, app_base_contract_1.normalizeAppArtifactContentType)(file.contentType) !== 'text/html')
            continue;
        try {
            if (new TextEncoder().encode(file.text).length >
                app_base_bindings_1.APP_BASE_BINDING_TEMPLATE_MAX_BYTES)
                throw new Error('HTML template exceeds the template byte budget');
            const engine = (0, app_base_bindings_1.createAppBaseBindingRuntime)(parse(file.text), {
                budgets: app_base_bindings_1.APP_BASE_BINDING_BUDGETS,
                urlIssue: app_base_url_policy_1.appBaseUrlPolicyIssue,
            });
            const sources = engine.inspect();
            for (const route of routes?.filter(route => route.entry === file.path) ??
                []) {
                if (sources.some(source => !route.dataSourceKeys.includes(source)))
                    throw new Error('Binding source is not declared on the route');
            }
        }
        catch (error) {
            issues.push(`${file.path}: ${error instanceof Error ? error.message : 'Invalid bindings'}`);
        }
    }
    return issues;
}
/** Literal column references of every HTML template, per declared source. */
function appBaseBindingColumnRefs(files, parse) {
    return files.flatMap(file => (0, app_base_contract_1.normalizeAppArtifactContentType)(file.contentType) === 'text/html' &&
        file.text !== undefined
        ? (0, app_base_bindings_1.createAppBaseBindingRuntime)(parse(file.text), {
            budgets: app_base_bindings_1.APP_BASE_BINDING_BUDGETS,
            urlIssue: app_base_url_policy_1.appBaseUrlPolicyIssue,
        })
            .inspectColumns()
            .map(ref => ({ path: file.path, ...ref }))
        : []);
}
